/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Projects_Locality_DescriptionInputs */

const cs_projects_locality_description = /** @type {(inputs: Projects_Locality_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Popis lokality`)
};

const en_projects_locality_description = /** @type {(inputs: Projects_Locality_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Locality description`)
};

/**
* | output |
* | --- |
* | "Locality description" |
*
* @param {Projects_Locality_DescriptionInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const projects_locality_description = /** @type {((inputs?: Projects_Locality_DescriptionInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Projects_Locality_DescriptionInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_projects_locality_description(inputs)
	return cs_projects_locality_description(inputs)
});